import BigSelect from './BigSelect';

export default BigSelect;
